import ProductPanel from './product-panel';

export default ProductPanel;